'use client';

import { MapPin, Phone, Mail, Clock } from 'lucide-react';

export default function Boutique() {
  return (
    <section
      id="boutique"
      className="relative py-24 sm:py-32 bg-[#0a0a0f] border-t border-[#D4AF37]/10 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="flex items-center justify-center gap-3 mb-4">
            <span className="block h-px w-10 bg-[#D4AF37]" />
            <span className="eyebrow">La Boutique</span>
            <span className="block h-px w-10 bg-[#D4AF37]" />
          </div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold leading-tight">
            <span className="text-[#F4E8C1]">Au cœur d'</span>
            <span className="text-gold-gradient">Anvers.</span>
          </h2>
          <p className="mt-5 max-w-2xl mx-auto text-[#F4E8C1]/65 font-light leading-relaxed">
            Une adresse discrète, un écrin de marbre et de bois sombre. La
            boutique MATAR vous accueille sur rendez-vous pour une expérience
            d'essayage privilégiée.
          </p>
        </div>

        {/* Boutique image */}
        <div className="relative mb-14">
          <div className="relative aspect-[16/9] sm:aspect-[21/9] overflow-hidden border-gold-thin glow-gold">
            <img
              src="/images/boutique-antwerp.png"
              alt="Façade de la boutique MATAR STYLE CUIR à Anvers"
              className="w-full h-full object-cover"
              style={{ filter: 'brightness(0.7) saturate(1.1)' }}
            />
            <div
              className="absolute inset-0"
              style={{
                background:
                  'linear-gradient(180deg, transparent 40%, rgba(10,10,15,0.85) 100%)',
              }}
            />
            <div className="absolute bottom-5 left-5 right-5 flex flex-col sm:flex-row sm:items-end sm:justify-between gap-3">
              <div>
                <div className="font-display text-xl sm:text-2xl text-[#F4E8C1] font-semibold tracking-wide">
                  MATAR STYLE CUIR
                </div>
                <div className="text-[#D4AF37] text-sm mt-1 italic font-serif">
                  Anvers · Belgique
                </div>
              </div>
              <div className="text-[10px] uppercase tracking-[0.3em] text-[#F4E8C1]/70">
                Sur rendez-vous
              </div>
            </div>
          </div>
        </div>

        {/* Info cards */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {[
            {
              icon: MapPin,
              label: 'Adresse',
              lines: ['Rue Nationale 14', '2000 Anvers', 'Belgique'],
            },
            {
              icon: Clock,
              label: 'Horaires',
              lines: ['Mar — Sam : 10h — 19h', 'Dim — Lun : Fermé', 'Sur rendez-vous'],
            },
            {
              icon: Phone,
              label: 'Téléphone',
              lines: ['+32 3 555 14 02', '+32 470 88 19 14', 'WhatsApp disponible'],
            },
            {
              icon: Mail,
              label: 'Courriel',
              lines: ['atelier@matar-style-cuir', '.smartest-capital.org', 'Réponse sous 24h'],
            },
          ].map((card) => (
            <div
              key={card.label}
              className="bg-[#12121a] border border-[#D4AF37]/15 hover:border-[#D4AF37]/45 transition-colors p-6 group"
            >
              <div className="w-10 h-10 mb-4 flex items-center justify-center border border-[#D4AF37]/30 group-hover:bg-[#D4AF37] transition-colors">
                <card.icon size={18} className="text-[#D4AF37] group-hover:text-[#0a0a0f]" />
              </div>
              <div className="text-[10px] uppercase tracking-[0.3em] text-[#D4AF37] mb-3">
                {card.label}
              </div>
              <div className="space-y-1">
                {card.lines.map((line, i) => (
                  <p
                    key={i}
                    className={`text-sm font-light ${
                      i === 0 ? 'text-[#F4E8C1]' : 'text-[#F4E8C1]/60'
                    }`}
                  >
                    {line}
                  </p>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
